/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type CreateTeamInput = {
  name: string;
  staffGUIDs: Array<string | number>;
};

export type DeleteTeamInput = {
  guid: string | number;
};

export type SettingsPageTeamManagementViewQueryVariables = Exact<{ [key: string]: never; }>;


export type SettingsPageTeamManagementViewQuery = { teams: Array<{ guid: string, name: string, staffs: Array<{ guid: string, name: string | null, displayName: string }> }>, viewer: { staff: { guid: string } } };

export type CreateTeamMutationVariables = Exact<{
  input: Types.CreateTeamInput;
}>;


export type CreateTeamMutation = { createTeam: { __typename: 'CreateTeamSuccessPayload' } };

export type DeleteTeamMutationVariables = Exact<{
  input: Types.DeleteTeamInput;
}>;


export type DeleteTeamMutation = { deleteTeam: { __typename: 'DeleteTeamSuccessPayload' } };


export const SettingsPageTeamManagementViewDocument = gql`
    query SettingsPageTeamManagementView {
  teams {
    guid
    name
    staffs {
      guid
      name
      displayName
    }
  }
  viewer {
    staff {
      guid
    }
  }
}
    `;

/**
 * __useSettingsPageTeamManagementViewQuery__
 *
 * To run a query within a Vue component, call `useSettingsPageTeamManagementViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettingsPageTeamManagementViewQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSettingsPageTeamManagementViewQuery();
 */
export function useSettingsPageTeamManagementViewQuery(options: VueApolloComposable.UseQueryOptions<SettingsPageTeamManagementViewQuery, SettingsPageTeamManagementViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SettingsPageTeamManagementViewQuery, SettingsPageTeamManagementViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SettingsPageTeamManagementViewQuery, SettingsPageTeamManagementViewQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SettingsPageTeamManagementViewQuery, SettingsPageTeamManagementViewQueryVariables>(SettingsPageTeamManagementViewDocument, {}, options);
}
export function useSettingsPageTeamManagementViewLazyQuery(options: VueApolloComposable.UseQueryOptions<SettingsPageTeamManagementViewQuery, SettingsPageTeamManagementViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SettingsPageTeamManagementViewQuery, SettingsPageTeamManagementViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SettingsPageTeamManagementViewQuery, SettingsPageTeamManagementViewQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SettingsPageTeamManagementViewQuery, SettingsPageTeamManagementViewQueryVariables>(SettingsPageTeamManagementViewDocument, {}, options);
}
export type SettingsPageTeamManagementViewQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SettingsPageTeamManagementViewQuery, SettingsPageTeamManagementViewQueryVariables>;
export const CreateTeamDocument = gql`
    mutation createTeam($input: CreateTeamInput!) {
  createTeam(input: $input) {
    __typename
  }
}
    `;

/**
 * __useCreateTeamMutation__
 *
 * To run a mutation, you first call `useCreateTeamMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateTeamMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateTeamMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateTeamMutation(options: VueApolloComposable.UseMutationOptions<CreateTeamMutation, CreateTeamMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateTeamMutation, CreateTeamMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateTeamMutation, CreateTeamMutationVariables>(CreateTeamDocument, options);
}
export type CreateTeamMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateTeamMutation, CreateTeamMutationVariables>;
export const DeleteTeamDocument = gql`
    mutation deleteTeam($input: DeleteTeamInput!) {
  deleteTeam(input: $input) {
    __typename
  }
}
    `;

/**
 * __useDeleteTeamMutation__
 *
 * To run a mutation, you first call `useDeleteTeamMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTeamMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteTeamMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useDeleteTeamMutation(options: VueApolloComposable.UseMutationOptions<DeleteTeamMutation, DeleteTeamMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteTeamMutation, DeleteTeamMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteTeamMutation, DeleteTeamMutationVariables>(DeleteTeamDocument, options);
}
export type DeleteTeamMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteTeamMutation, DeleteTeamMutationVariables>;